export default {
    data() {
        return {
            cardsInfo: [
                {
                    id: 0,
                    isActiveLogo: true,
                    colorTitle: 'avea-white',
                    title: 'Приглашаем посетить наш стенд!',
                    action: () => this.uploadFile('news_1.pdf', 'banner'),
                    urlDownload: 'news_1.pdf',
                    text: 'Будем ждать вас на стенде № 21Е20 с 26 по 29 мая на выставке «Металлообработка 2025» в г. Москва',
                    img: 'banners/banner_1.webp'
                },
                {
                    id: 1,
                    colorTitle: 'dark-purple',
                    action: () => this.routToBanner(),
                    title: 'Интеллектуальное решение для вашего производства',
                    text: 'Оцените возможности роботизированной ячейки с ЧПУ, промышленным роботом и координатно-измерительной машиной на выставке «Металлообработка 2025»',
                    img: 'banners/banner_2.webp'
                },
            ],
        }
    },
    methods: {
        routToBanner() {
            window.open('https://roboyachejka.ru/', '_blank')
        }
    }
}